module.exports = __webpack_public_path__ + "img/fmsgpj_lanse.a0944979.png";